/* Build-your-box (sections/lumi-box-builder.liquid).
   Prices shown here are a preview of what Shopify's automatic discounts will charge; the discounts
   are the source of truth. Gifts are "Free Gift" variants tagged with the _lumi_box_gift line
   property, so they can be reconciled (added, swapped, removed) whenever the box changes.
   Long-distance layout (cfg.hh): every character has one card per box ("his" / "hers"), so the state is keyed
   "side:slug" and each kit line carries a hidden _for property. Tiers still count both boxes together. Gifts are
   decided by the cart, not the page: once any kit line has _for, every gift is added once per box. */
(() => {
  const root = document.querySelector('[data-bb]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-bb-config]').textContent);
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const GIFT_PROP = '_lumi_box_gift';

  const cards = $$('[data-bb-card]');
  const offers = [...document.querySelectorAll('[data-bb-tier]')];
  const HH = !!cfg.hh;
  const MIN_EACH = HH ? (cfg.minEach || 3) : 0; // long distance: kits needed in each box when they ship apart
  const SIDES = HH ? ['his', 'hers'] : [];
  const keyOf = (c) => c.dataset.key || c.dataset.slug;
  const sideOf = (key) => (key.includes(':') ? key.split(':')[0] : '');
  const bySlug = Object.fromEntries(cards.map((c) => [keyOf(c), c]));
  const kitVariants = new Set(cards.map((c) => c.dataset.variant).filter(Boolean).map(Number));
  const tiers = cfg.tiers.map((t) => ({ ...t, qty: +t.qty, each: +t.each })).sort((a, b) => a.qty - b.qty);
  const top = tiers[tiers.length - 1];
  const qty = {};
  const order = [];
  /* Extras (the Tools tab): tool packs and the acrylic board, bought on their own. Kept apart from the kits: they get
     their own tray row and never count toward the 3 / 6 / 12 tiers or the gifts those unlock. xq = key -> how many. */
  const XS = cfg.extras || [];
  const xBy = Object.fromEntries(XS.map((x) => [x.key, x]));
  const xq = {};
  const xCount = () => XS.reduce((s, x) => s + (xq[x.key] || 0), 0);
  const xTotal = () => Math.round(XS.reduce((s, x) => s + (xq[x.key] || 0) * +x.price, 0) * 100) / 100;
  const xCards = [...root.querySelectorAll('[data-bb-x]')];
  /* Long-distance packs: one tap deals random characters into both boxes. `pack` is the chosen pack's key; while
     it's set the boxes must hold at least its per-world count each, and the cart gets the pack's gifts. */
  const PACKS = HH ? cfg.packs || [] : [];
  const packCards = [...document.querySelectorAll('[data-ldr-pack]')];
  let pack = '';
  const packOf = (k) => PACKS.find((p) => p.key === k) || null;
  const packWorlds = (p) => (p.world === 'both' ? ['wild', 'jurassic'] : [p.world]);
  const worldOf = Object.fromEntries(cards.map((c) => [keyOf(c), c.closest('[data-bb-world]').dataset.bbWorld]));
  const worldOfVariant = Object.fromEntries(cards.filter((c) => c.dataset.variant).map((c) => [+c.dataset.variant, worldOf[keyOf(c)]]));
  /* The gift box comes in two designs: the one matching most of the box's kits, a tie going to the dinos. Same rule
     as snippets/lumi-box-world.liquid, so the drawer and the builder never disagree. `sd` limits it to one box. */
  const boxWorld = (kitLines, sd) => {
    let j = 0;
    let w = 0;
    kitLines.forEach((l) => {
      if (sd && (l.properties || {})._for !== sd) return;
      if (worldOfVariant[l.variant_id] === 'jurassic') j += l.quantity;
      else if (worldOfVariant[l.variant_id] === 'wild') w += l.quantity;
    });
    return w > j ? 'wild' : 'jurassic';
  };
  const NOUN = { wild: ['animal', 'animals'], jurassic: ['dino', 'dinos'] };
  const PG = cfg.packGifts || {};
  const packGifts = (p) => [p.boards > 0 && PG.board && PG.board.variant && { ...PG.board, qty: +p.boards }, p.tools > 0 && PG.tool && PG.tool.variant && { ...PG.tool, qty: +p.tools }].filter(Boolean);
  const packName = (p) => (/pack$/i.test(p.title) ? p.title : p.title + ' pack'); // "Both Worlds pack", "Animal Pack"
  const packTotal = (p) => p.per * packWorlds(p).length * 2;
  /* The first gap in a pack: a box short of the pack's count in one world ("add 1 more dino to her box"). */
  function packShort(p) {
    for (const sd of SIDES) for (const w of packWorlds(p)) {
      const have = order.filter((k) => sideOf(k) === sd && worldOf[k] === w).length;
      if (have < p.per) {
        const k = p.per - have, box = ((cfg.boxes || {})[sd] || sd).toLowerCase();
        return { sd, w, text: `add ${k} more ${NOUN[w][k > 1 ? 1 : 0]} to ${box}` };
      }
    }
    return null;
  }
  /* Deal a pack: per world, shuffle the buyable characters and give each box its own, so between them a couple
     gets the whole world (12 characters, 6 each). Only if a world ran short would a character repeat. */
  function dealPack(key, auto) {
    const p = packOf(key);
    if (!p) return;
    order.length = 0; Object.keys(qty).forEach((k) => delete qty[k]);
    packWorlds(p).forEach((w) => {
      const slugs = [...new Set(cards.filter((c) => c.dataset.variant && worldOf[keyOf(c)] === w).map((c) => c.dataset.slug))];
      for (let i = slugs.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [slugs[i], slugs[j]] = [slugs[j], slugs[i]]; }
      SIDES.forEach((sd, si) => {
        for (let i = 0; i < p.per; i++) {
          const k = `${sd}:${slugs[(si * p.per + i) % slugs.length]}`;
          if (!bySlug[k]) continue;
          order.push(k); qty[k] = (qty[k] || 0) + 1;
        }
      });
    });
    pack = key; goal = 0;
    render();
    root.dispatchEvent(new CustomEvent('bb:pack', { detail: { pack: key, n: order.length, order: order.slice(), auto: !!auto } }));
  }

  const round2 = (v) => Math.round(v * 100) / 100;
  const money = (v) => '$' + (Number.isInteger(round2(v)) ? round2(v) : round2(v).toFixed(2));
  const tierFor = (n) => [...tiers].reverse().find((t) => n >= t.qty) || null;
  const each = (n) => (tierFor(n) ? tierFor(n).each : +cfg.listPrice);
  const price = (n) => round2(n * each(n));
  const giftsFor = (tier) => (tier ? cfg.gifts.filter((g) => g.tier === tier.gift) : []);
  const saved = (n) => round2(n * +cfg.listPrice - price(n));
  const listJoin = (a) => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' & ' + a[a.length - 1]);
  const shipAt = (() => { for (let n = 1; n <= 60; n++) if (price(n) >= cfg.freeShip) return n; return Infinity; })();

  /* What each of the 12 slots in the tray stands for. Tier slots say how much the box saves by then
     ($15 off, $45 off, $140 off); their free gifts sit underneath the slot, not in it. Everything
     else stays blank so the eye goes straight to the rewards. */
  const milestone = {};
  tiers.forEach((t) => { const off = money(Math.round(saved(t.qty))); milestone[t.qty] = { tone: t.tone, off, html: `Save<i>${off}</i>` }; });
  /* Second tray row, "Your free gifts": one chip per unlock point. Free shipping gets its own chip at the count
     that first clears the free-shipping total (not at 12), so it's dropped from the 12-kit chip. The 6-kit chip
     drops away at 12, because 12 swaps the Sleeve for the bigger set. */
  const giftChips = tiers.filter((t) => giftsFor(t).length).map((t) => ({ at: t.qty, tone: t.tone, until: t === top ? Infinity : top.qty, gifts: giftsFor(t).filter((g) => g.variant || g.image) }));
  // Long distance charges shipping on the page, so there's no free-shipping reward there.
  if (shipAt !== Infinity && !HH) giftChips.push({ at: shipAt, tone: 'gold', until: Infinity, gifts: [{ label: 'Free shipping', icon: '🚚' }] });
  giftChips.sort((a, b) => a.at - b.at);
  const truck = (root.querySelector('[data-bb-truck]') || {}).innerHTML || '🚚';
  // Each thumbnail opens that gift's info panel (data-bb-gift = the label, handleized like Liquid's | handleize).
  const giftKey = (l) => String(l || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const giftThumb = (g, at) => {
    const attrs = `data-bb-gift="${giftKey(g.label)}" data-bb-unlock="Free once your box reaches ${at} kits" data-bb-at="${at}" role="button" tabindex="0" aria-label="About the free ${g.label}"`;
    return g.image ? `<span ${attrs}><img src="${g.image}" alt="${g.label}"></span>` : `<i ${attrs}>${g.icon === '🚚' || !g.icon ? truck : g.icon}</i>`;
  };

  function set(slug, d) {
    const q = (qty[slug] || 0) + d;
    if (q < 0) return;
    qty[slug] = q;
    if (d > 0) order.push(slug); else order.splice(order.lastIndexOf(slug), 1);
    render();
    root.dispatchEvent(new CustomEvent('bb:change', { detail: { key: slug, d, n: order.length, order: order.slice() } }));
  }
  function setX(key, d) {
    const q = (xq[key] || 0) + d;
    if (q < 0 || !xBy[key]) return;
    if (q) xq[key] = q; else delete xq[key];
    render();
  }
  const total = () => order.length;
  window.lumiBoxCount = () => order.length; // read by the gift panel below
  const sideCount = (sd) => order.filter((k) => sideOf(k) === sd).length;


  let lastTierQty = 0, lastPage = 0, lastPages = 0;
  /* The box size the shopper picked from the 3/6/12 offers. It stays selected (and the tray shows "2 of 6 picked")
     until the box reaches it; picking more than that moves the selection up to the tier actually reached. */
  let goal = 0;
  function markPage() {
    const el = $('[data-bb-slots]'), dots = $('[data-bb-slot-dots]');
    if (!dots || dots.hidden) return;
    const k = Math.round(el.scrollLeft / Math.max(1, el.clientWidth));
    [...dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === k)));
  }
  let qvSync = () => {};
  /* The box survives a refresh or a later visit: the pick order is kept in this browser's localStorage
     (device-only, never sent anywhere) for 30 days, and cleared once the box goes into the cart. */
  const BOX_KEY = HH ? 'lumi_ldr_box_v1' : 'lumi_box_v1', BOX_TTL = 30 * 864e5;
  function saveBox() {
    try {
      if (order.length || goal || xCount()) localStorage.setItem(BOX_KEY, JSON.stringify({ order, goal, pack, x: xq, t: Date.now() }));
      else localStorage.removeItem(BOX_KEY);
    } catch (e) { /* private mode / storage full: the box just won't persist */ }
  }
  function restoreBox() {
    // A shared link (?box=his-foxy,hers-bao,…) wins over what this browser had saved.
    const qs = new URLSearchParams(location.search);
    // ?kits=12 (the box-gifts claim link) arrives with that box size picked, after any saved box is restored.
    const kitsParam = +qs.get('kits');
    if (tiers.some((t) => t.qty === kitsParam)) queueMicrotask(() => {
      goal = kitsParam; pack = ''; render();
      const url = new URL(location.href); url.searchParams.delete('kits'); history.replaceState(history.state, '', url);
      // Bring the picked offer into view if it's below the fold (phones: the offers sit under the gallery).
      const card = document.querySelector('[data-bb-tier="' + kitsParam + '"]');
      if (card && card.getBoundingClientRect().bottom > innerHeight) setTimeout(() => card.scrollIntoView({ behavior: 'smooth', block: 'center' }), 400);
    });
    const shared = HH && qs.get('box');
    if (shared) {
      shared.split(',').map((k) => k.replace('-', ':')).forEach((k) => { if (bySlug[k]) { order.push(k); qty[k] = (qty[k] || 0) + 1; } });
      if (order.length) { root.bbShared = true; pack = packOf(qs.get('pack')) ? qs.get('pack') : ''; return; }
    }
    try {
      const saved = JSON.parse(localStorage.getItem(BOX_KEY) || 'null');
      if (!saved || !Array.isArray(saved.order) || Date.now() - saved.t > BOX_TTL) { localStorage.removeItem(BOX_KEY); return; }
      goal = +saved.goal || 0;
      pack = packOf(saved.pack) ? saved.pack : '';
      saved.order.forEach((slug) => { if (bySlug[slug]) { order.push(slug); qty[slug] = (qty[slug] || 0) + 1; } });
      Object.entries(saved.x || {}).forEach(([k, q]) => { if (xBy[k] && +q > 0) xq[k] = Math.min(99, +q); });
    } catch (e) {}
  }
  function render() {
    const n = total();
    const tier = tierFor(n);

    const target = pack ? 0 : goal > n ? goal : (tier ? tier.qty : 0);
    const P = packOf(pack), short = P ? packShort(P) : null;
    packCards.forEach((el) => {
      const on = el.dataset.ldrPack === pack;
      el.classList.toggle('is-on', on);
      const st = $('[data-bb-pack-state]', el);
      st.classList.toggle('is-got', on && !short);
      st.textContent = on ? (short ? `Your pick · ${short.text}` : '✓ In your boxes · gifts added automatically') : '';
    });
    const bar = $('[data-bb-packbar]');
    if (bar) {
      bar.hidden = !P;
      if (P) $('[data-bb-packbar-txt]', bar).innerHTML = `<b>${P.title}</b> · ${n} kits, dealt at random with no character in both boxes. Swap any you like.`;
    }
    offers.forEach((el) => {
      const at = +el.dataset.bbTier;
      const on = at === target;
      el.classList.toggle('is-on', on);
      const st = $('[data-bb-offer-state]', el);
      const t = tiers.find((x) => x.qty === at);
      const reached = on && n >= at;
      st.classList.toggle('is-got', reached);
      // The ticked ring already says which offer is picked, so no "Your pick · n of N" line while filling it.
      st.textContent = on && !reached
        ? ''
        : on
        ? (giftsFor(t).length ? '✓ Your box · gifts added automatically' : '✓ Your box')
        : at > n ? (n ? `Add ${at - n} more kit${at - n > 1 ? 's' : ''} to unlock` : '') : '';
    });

    cards.forEach((c) => {
      const q = qty[keyOf(c)] || 0;
      c.classList.toggle('is-sel', q > 0);
      const step = $('[data-bb-step]', c);
      const want = q ? 'qty' : 'add';
      if (step.dataset.mode === want && want === 'qty') { $('span', step).textContent = q; }
      else {
        step.dataset.mode = want;
        step.innerHTML = q
          ? `<div class="bb-qty"><button type="button" data-bb-d="-1" aria-label="Remove one ${c.dataset.name}">−</button><span>${q}</span><button type="button" data-bb-d="1" aria-label="Add another ${c.dataset.name}">+</button></div>`
          : `<button type="button" class="bb-add" data-bb-d="1" aria-label="Add ${c.dataset.name}">Add +</button>`;
      }
    });

    xCards.forEach((c) => {
      const q = xq[c.dataset.bbX] || 0;
      c.classList.toggle('is-sel', q > 0);
      const step = $('[data-bb-xstep]', c);
      const want = q ? 'qty' : 'add';
      if (step.dataset.mode === want && want === 'qty') { $('span', step).textContent = q; return; }
      step.dataset.mode = want;
      step.innerHTML = q
        ? `<div class="bb-qty"><button type="button" data-bb-xd="-1" aria-label="Remove one ${c.dataset.name}">−</button><span>${q}</span><button type="button" data-bb-xd="1" aria-label="Add another ${c.dataset.name}">+</button></div>`
        : `<button type="button" class="bb-add" data-bb-xd="1" aria-label="Add ${c.dataset.name}">Add +</button>`;
    });
    // Second tray row, only once something's in it: the extras, apart from the kits above.
    const xr = $('[data-bb-extras]');
    if (xr) {
      const picked = XS.filter((x) => xq[x.key]);
      xr.hidden = !picked.length;
      xr.innerHTML = picked.length ? `<span class="bb-giftrow-h">Your <span>extras</span></span>` + picked.map((x) =>
        `<span class="bb-xchip"><span class="bb-xchip-img"><img src="${x.image}" alt=""></span><b>${x.short}${xq[x.key] > 1 ? ` <em>×${xq[x.key]}</em>` : ''}</b><button type="button" class="bb-xchip-x" data-bb-xrm="${x.key}" aria-label="Remove one ${x.label}">×</button></span>`).join('') : '';
    }

    /* Pages of 12: past 12 kits the tray grows another page of 12 (two rows of 6 on phones) and you swipe between
       them. With 12 or fewer it's the one page, laid out exactly as before. */
    const pages = Math.max(1, Math.ceil(n / top.qty));
    const slots = [];
    for (let i = 1; i <= pages * top.qty; i++) {
      const slug = order[i - 1];
      const m = milestone[i];
      const tone = m ? ` t-${m.tone}` : '';
      if (slug) {
        const img = $('.bb-card-img', bySlug[slug]);
        // A reached tier keeps saying what it saved, on a band under the character.
        const band = m && milestone[i].off ? `<span class="bb-slot-band">Saved ${milestone[i].off}</span>` : (m ? '<span class="bb-slot-tick">✓</span>' : '');
        const sd = sideOf(slug) ? ` s-${sideOf(slug)}` : '';
        slots.push(`<div class="bb-slot is-full${tone}${sd}"><img src="${img.currentSrc || img.src}" alt="">${band}<button type="button" class="bb-slot-x" data-bb-rm="${i - 1}" aria-label="Remove ${bySlug[slug].dataset.name}">×</button></div>`);
      } else {
        slots.push(`<div class="bb-slot${tone}">${m ? `<span class="bb-slot-lbl">${m.html}</span>` : ''}</div>`);
      }
    }
    const slotEl = $('[data-bb-slots]');
    const pageHtml = [];
    for (let pg = 0; pg < pages; pg++) pageHtml.push(`<div class="bb-slot-page">${slots.slice(pg * top.qty, (pg + 1) * top.qty).join('')}</div>`);
    slotEl.innerHTML = pageHtml.join('');
    slotEl.classList.toggle('is-paged', pages > 1);
    const dots = $('[data-bb-slot-dots]');
    if (dots) {
      dots.hidden = pages < 2;
      dots.innerHTML = pages > 1 ? Array.from({ length: pages }, (_, k) => `<button type="button" data-bb-page="${k}" aria-label="Kits ${k * top.qty + 1} to ${(k + 1) * top.qty}"></button>`).join('') : '';
    }
    // Follow the newest kit onto its page.
    const cur = Math.max(0, Math.ceil(n / top.qty) - 1);
    if (pages > 1 && (cur !== lastPage || pages !== lastPages)) requestAnimationFrame(() => slotEl.scrollTo({ left: cur * slotEl.clientWidth, behavior: lastPages ? 'smooth' : 'auto' }));
    lastPage = cur; lastPages = pages;
    markPage();
    // The picked box size: every slot up to it is outlined, and its last slot is enlarged and pulses.
    if (goal > n) slotEl.querySelectorAll('.bb-slot-page > *').forEach((el, k) => { el.classList.toggle('is-goal', k < goal); el.classList.toggle('is-goal-end', k === goal - 1); });
    // A pack swaps the tier gifts for its own set, one per box.
    if (P) $('[data-bb-slot-gifts]').innerHTML = `<span class="bb-giftrow-h">Your <span>free gifts</span></span><span class="bb-slot-gift${short ? '' : ' is-got'}"><span class="bb-slot-gift-tiles">${packGifts(P).map((g) => `<span data-bb-gift="${giftKey(g.label)}" data-bb-unlock="Free with the ${packName(P)}, one in each box" role="button" tabindex="0" aria-label="About the free ${g.label}">${g.image ? `<img src="${g.image}" alt="${g.label}">` : ''}</span>`).join('')}</span><b>${short ? `With the ${packName(P)}` : '✓ FREE ×2'}</b></span>`;
    else $('[data-bb-slot-gifts]').innerHTML = `<span class="bb-giftrow-h">Your <span>free gifts</span></span>` + giftChips.filter((c) => n < c.until).map((c) => {
      // Free shipping goes by the cart total, so extras can tip it over before the kit count gets there.
      const on = n >= c.at || (c.at === shipAt && !HH && n > 0 && price(n) + xTotal() >= cfg.freeShip);
      return `<span class="bb-slot-gift${on ? ' is-got' : ''}"><span class="bb-slot-gift-tiles">${c.gifts.map((g) => giftThumb(g, c.at)).join('')}</span><b>${on ? (HH ? '✓ FREE ×2' : '✓ FREE') : `<span class="bb-lg">Unlocks at </span>${c.at} kits`}</b></span>`;
    }).join('');

    // Progress counter "(2/6)" (Aaron, 10 Oct: replaces "You're saving $X" / "2 of 6 kits picked"; phones only, hidden
    // on desktop in CSS). Counts toward the picked box size, else the next 3/6/12 tier, else the next page of 12.
    const sv = $('[data-bb-saving]');
    const svNow = n && tier ? round2(saved(n)) : 0;
    const nextTier = tiers.find((t) => t.qty > n);
    const of = P && n <= packTotal(P) ? packTotal(P) : goal > n ? goal : nextTier ? nextTier.qty : Math.ceil((n + 1) / top.qty) * top.qty;
    sv.innerHTML = n ? `<b>(${n}/${of})</b>` : '';
    sv.classList.toggle('has-goal', goal > n);
    sv.classList.toggle('is-on', svNow > 0);
    const tq = tier ? tier.qty : 0;
    if (tq > lastTierQty) { sv.classList.remove('is-pop'); void sv.offsetWidth; sv.classList.add('is-pop'); }
    lastTierQty = tq;
    const cta = $('[data-bb-cta]');
    cta.disabled = false; // empty: "Pick your kits" scrolls to the characters (pickKits)
    const xn = xCount();
    cta.innerHTML = n || xn
      ? `Add to cart · ${[n && `${n} kit${n > 1 ? 's' : ''}`, xn && `${xn} extra${xn > 1 ? 's' : ''}`].filter(Boolean).join(' + ')} · ${money(price(n) + xTotal())}`
      : 'Pick your kits';
    if (HH) renderSides(n, cta);
    renderYours(n);
    $('[data-bb-clear]').style.visibility = n || xn ? '' : 'hidden'; // keeps its space, so the grid never jumps
    $('[data-bb-error]').hidden = true;
    root.style.setProperty('--bb-tray-h', $('[data-bb-tray]').offsetHeight + 'px');
    qvSync();
    saveBox();
  }

  /* Long distance: a count on each box's header, a His · n / Hers · n line on the tray, and a CTA that needs a
     kit in both boxes before it moves on to the addresses. */
  /* Flat shipping, in words, for the page and the address step: one charge per address. */
  const shipRate = (n) => { const S = cfg.ship || {}; return S.big && n >= S.bigAt ? S.bigPrice : S.stdPrice; };
  const shipAddrs = () => (root.bbShipTo === 'one' ? 1 : 2);
  function renderShipNote(n) {
    const el = $('[data-bb-shipnote]'), S = cfg.ship || {};
    if (!el || !S.std) return;
    const a = shipAddrs();
    el.innerHTML = n
      ? `Shipping: <b>${money(shipRate(n))}${a > 1 ? ' × 2 addresses = ' + money(shipRate(n) * 2) : ''}</b>, added before checkout. Ships worldwide.`
      : `Flat shipping ${money(S.stdPrice)}${a > 1 ? ' per address' : ''} (${money(S.bigPrice)}${a > 1 ? ' each' : ''} for ${S.bigAt}+ kits). Ships worldwide.`;
  }
  function renderSides(n, cta) {
    renderShipNote(n);
    const lbl = cfg.sides || {};
    SIDES.forEach((sd) => {
      const k = sideCount(sd);
      const el = document.querySelector(`[data-bb-side="${sd}"] [data-bb-side-n]`);
      if (el) el.textContent = `${k} kit${k === 1 ? '' : 's'}`;
    });
    const ts = $('[data-bb-tray-sides]');
    if (ts) ts.innerHTML = SIDES.map((sd) => `<span class="bb-ts bb-ts-${sd}"><i></i>${lbl[sd]} · ${sideCount(sd)}</span>`).join('');
    if (!n) return;
    const empty = SIDES.find((sd) => !sideCount(sd));
    if (empty) { cta.disabled = true; cta.innerHTML = `Now pick ${lbl[empty].toLowerCase()}`; return; }
    // Two parcels cost the same to post at 3 kits as at 8, so a box going to its own address needs at least 3.
    const low = root.bbShipTo !== 'one' && SIDES.find((sd) => sideCount(sd) < MIN_EACH);
    if (low) { const k = MIN_EACH - sideCount(low); cta.disabled = true; cta.innerHTML = `Add ${k} more to ${lbl[low].toLowerCase()} box · ${MIN_EACH} each minimum`; return; }
    const P = packOf(pack), short = P && packShort(P);
    if (short) { cta.disabled = true; cta.innerHTML = short.text.replace(/^./, (c) => c.toUpperCase()); return; }
    cta.innerHTML = `Next: ${root.bbShipTo === 'one' ? 'where it goes' : 'where they go'} · ${n} kit${n > 1 ? 's' : ''} · ${money(price(n))}`;
  }

  /* "Your free gifts" panel (gift_display = combined): earned gifts in full colour, the rest faded with when
     they unlock. data-until drops a gift that a bigger box swaps out; data-top-qty doubles one at the top tier. */
  const yours = document.querySelector('[data-bb-yours]');
  function renderYours(n) {
    if (!yours) return;
    let val = 0, got = 0;
    yours.querySelectorAll('.bb-yours-item').forEach((li) => {
      const at = +li.dataset.at;
      const gone = n >= (+li.dataset.until || Infinity);
      const on = n >= at && !gone;
      const q = n >= top.qty && li.dataset.topQty ? +li.dataset.topQty : +li.dataset.qty;
      li.hidden = gone;
      li.classList.toggle('is-on', on);
      const yq = li.querySelector('[data-bb-yq]');
      yq.hidden = q < 2; yq.textContent = `×${q}`;
      li.querySelector('[data-bb-ystate]').innerHTML = on ? `<s>${money(q * +li.dataset.each)}</s> <b>FREE</b>` : `Unlocks at <span>${at} kits</span>`;
      if (on) { val += q * +li.dataset.each; got++; }
    });
    yours.querySelector('[data-bb-yours-sum]').textContent = got ? `${money(val)} value unlocked` : '';
  }

  /* ---- tray only while the builder is on screen */
  const tray = $('[data-bb-tray]');
  // The tray shows while the builder's grid is on screen and hides as soon as the grid's last row has risen above it,
  // so the section needs no tray-high blank space at its foot (Aaron, 23 Oct: big gap before the next section on phones).
  const bbWrap = root.querySelector('.bb-wrap');
  const trayVis = () => {
    const r = bbWrap.getBoundingClientRect(), vh = innerHeight, th = tray.offsetHeight || 0;
    tray.classList.toggle('is-on', r.top < vh * 0.7 && r.bottom > vh - th + 24);
  };
  addEventListener('scroll', trayVis, { passive: true }); addEventListener('resize', trayVis); trayVis();

  /* ---- cart */
  async function req(path, body) {
    const r = await fetch(ROUTES + path, body === undefined
      ? { credentials: 'same-origin', headers: { Accept: 'application/json' } }
      : { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || `Cart error (${r.status})`);
    return data;
  }

  /* Make the gift lines match the number of box kits in the cart. Returns true if it changed anything. */
  let reconciling = false;
  async function reconcile(cart) {
    if (reconciling) return false;
    reconciling = true;
    try {
      cart = cart || (await req('cart.js'));
      const kitLines = cart.items.filter((l) => kitVariants.has(l.variant_id));
      const kits = kitLines.reduce((s, l) => s + l.quantity, 0);
      // A long-distance cart (any kit bound for a box) gets a full set of gifts per box, each tagged with its box.
      const boxes = kitLines.some((l) => l.properties && l.properties._for) ? ['his', 'hers'] : [''];
      // A pack's kits carry _pack: that pack's gifts per box (tagged with its name for the drawer), not the tier's.
      const pk = packOf((kitLines.find((l) => l.properties && l.properties._pack) || { properties: {} }).properties._pack);
      const tag = pk ? packName(pk) : tierFor(kits) ? String(tierFor(kits).qty) : '';
      const giftSet = pk ? packGifts(pk) : giftsFor(tierFor(kits)).filter((g) => g.variant);
      const want = boxes.flatMap((sd) => giftSet.map((g) => ({ id: +(g.variantJ && boxWorld(kitLines, sd) === 'jurassic' ? g.variantJ : g.variant), qty: +g.qty, sd })));
      const have = cart.items.filter((l) => l.properties && l.properties[GIFT_PROP]);
      const same = have.length === want.length && want.every((g) => have.some((l) => l.variant_id === g.id && l.quantity === g.qty && l.properties[GIFT_PROP] === tag && (l.properties._for || '') === g.sd));
      let changed = false;
      if (!same) {
        if (have.length) await req('cart/update.js', { updates: Object.fromEntries(have.map((l) => [l.key, 0])) });
        if (want.length) await req('cart/add.js', { items: want.map((g) => ({ id: g.id, quantity: g.qty, properties: g.sd ? { [GIFT_PROP]: tag, _for: g.sd } : { [GIFT_PROP]: tag } })) });
        changed = true;
      }
      /* Second delivery (long distance only): one line while the cart is going to two addresses, switching to its
         $0 "Free" variant once the goods reach cfg.ship.freeOver. The goods total excludes the delivery line itself. */
      /* Long distance: flat shipping is charged on the page, one line per address (qty 1 or 2, from the ldr_addresses
         attribute the address step sets), $10 each or $15 each from cfg.ship.bigAt kits. Added only once the addresses
         are in; removed from any cart that isn't a two-box cart. */
      const S = cfg.ship || {};
      const shipIds = [S.std, S.big].filter(Boolean).map(Number);
      if (shipIds.length) {
        if (changed) cart = await req('cart.js');
        const shipLines = cart.items.filter((l) => shipIds.includes(l.variant_id));
        const addrs = boxes.length > 1 ? +((cart.attributes || {}).ldr_addresses || 0) : 0;
        const wantShip = addrs ? (S.big && kits >= S.bigAt ? +S.big : +S.std) : 0;
        const ok = wantShip ? shipLines.length === 1 && shipLines[0].variant_id === wantShip && shipLines[0].quantity === addrs : !shipLines.length;
        if (!ok) {
          if (shipLines.length) await req('cart/update.js', { updates: Object.fromEntries(shipLines.map((l) => [l.key, 0])) });
          if (wantShip) await req('cart/add.js', { items: [{ id: wantShip, quantity: addrs }] });
          changed = true;
        }
      }
      return changed;
    } finally { reconciling = false; }
  }

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { location.href = ROUTES + 'cart'; return; }
    const sections = await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`, { credentials: 'same-origin' }).then((r) => r.json());
    drawer.renderContents({ sections });
  }

  const lineItems = () => {
    const kits = Object.entries(qty).filter(([, q]) => q > 0).map(([k, q]) => {
      const item = { id: +bySlug[k].dataset.variant, quantity: q };
      if (sideOf(k)) item.properties = pack ? { _for: sideOf(k), _pack: pack } : { _for: sideOf(k) };
      return item;
    });
    // Extras: the 1 / 3 / 6-packs are all the same tool kit variant, so they merge into one line.
    const xv = {};
    XS.forEach((x) => { if (xq[x.key]) xv[x.variant] = (xv[x.variant] || 0) + xq[x.key] * (+x.n || 1); });
    return kits.concat(Object.entries(xv).map(([id, q]) => ({ id: +id, quantity: q })));
  };
  function missingKits() {
    const err = $('[data-bb-error]');
    const missing = [...new Set(Object.entries(qty).filter(([k, q]) => q > 0 && !bySlug[k].dataset.variant).map(([k]) => bySlug[k].dataset.name))];
    if (!missing.length) return false;
    err.textContent = `${listJoin(missing)} ${missing.length > 1 ? "aren't" : "isn't"} available yet. Swap ${missing.length > 1 ? 'them' : 'it'} for another character.`;
    err.hidden = false;
    return true;
  }
  const clearBox = () => { order.length = 0; Object.keys(qty).forEach((k) => delete qty[k]); Object.keys(xq).forEach((k) => delete xq[k]); pack = ''; render(); };

  async function addToBag() {
    const cta = $('[data-bb-cta]');
    const err = $('[data-bb-error]');
    if (missingKits()) return;
    // Long distance: the kits only go in the cart once both addresses are in (snippets/lumi-ldr-address.liquid).
    if (HH) { root.dispatchEvent(new CustomEvent('bb:addresses', { detail: { n: total(), price: price(total()), counts: Object.fromEntries(SIDES.map((sd) => [sd, sideCount(sd)])) } })); return; }
    cta.classList.add('is-busy'); cta.disabled = true;
    try {
      await req('cart/add.js', { items: lineItems() });
      await reconcile();
      clearBox();
      await refreshDrawer();
    } catch (e) {
      err.textContent = e.message || 'Something went wrong. Please try again.';
      err.hidden = false;
    } finally { cta.classList.remove('is-busy'); cta.disabled = false; }
  }

  // Keep gifts honest when the box changes in the drawer (qty − / remove).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (ev) => {
      if (reconciling || !ev || ev.source === 'lumi-box-builder') return;
      try { if (await reconcile(ev.cartData && ev.cartData.items ? ev.cartData : null)) await refreshDrawer(); } catch (e) { /* the discount still decides the price */ }
    });
  }

  root.addEventListener('click', (ev) => {
    const b = ev.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.dataset.bbD) { set(keyOf(b.closest('[data-bb-card]')), +b.dataset.bbD); return; }
    if (b.dataset.bbXd) { setX(b.closest('[data-bb-x]').dataset.bbX, +b.dataset.bbXd); return; }
    if (b.dataset.bbXrm) { setX(b.dataset.bbXrm, -1); return; }
    // The × on a filled tray slot removes that exact kit.
    if (b.dataset.bbRm) { const [slug] = order.splice(+b.dataset.bbRm, 1); if (slug) { qty[slug]--; render(); } return; }
    if (b.hasAttribute('data-bb-clear')) { clearBox(); return; }
    if (b.hasAttribute('data-bb-cta')) { if (!total() && !xCount()) pickKits(); else addToBag(); }
  });

  // Desktop hand-over of the "Into the Wild" label (see .is-past-wild in the CSS).
  const wildEl = $('#bb-wild');
  if (wildEl) new IntersectionObserver(([e]) => root.classList.toggle('is-past-wild', !e.isIntersecting && e.boundingClientRect.top < 0), { rootMargin: '-110px 0px 0px 0px' }).observe(wildEl);
  // Same hand-over for the Tools panel: the two world tabs slide in above its label once Little Jurassic has gone by.
  const jurEl = $('#bb-jurassic');
  if (jurEl && $('#bb-tools')) new IntersectionObserver(([e]) => root.classList.toggle('is-past-jurassic', !e.isIntersecting && e.boundingClientRect.top < 0), { rootMargin: '-110px 0px 0px 0px' }).observe(jurEl);
  const toBuilder = () => ($('.bb-world, .bb-hh-mode') || root).scrollIntoView({ behavior: 'smooth' });
  // "Pick your kits" on an empty tray: take them to the characters and pulse the ones on screen, left to right.
  function pickKits() {
    // Long distance has the Better together band above its grid, so go straight to the first character there.
    const first = HH && cards[0];
    if (first) window.scrollTo({ top: first.getBoundingClientRect().top + window.scrollY - 150, behavior: 'smooth' });
    else toBuilder();
    setTimeout(() => {
      const vh = window.innerHeight;
      cards.filter((c) => { const r = c.getBoundingClientRect(); return r.bottom > 60 && r.top < vh - 80; }).slice(0, 12)
        .forEach((c, i) => setTimeout(() => { c.classList.remove('bb-pulse'); void c.offsetWidth; c.classList.add('bb-pulse'); }, i * 70));
    }, 650);
  }
  document.querySelectorAll('[data-bb-scroll]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); toBuilder(); }));
  // The offers live in the buy box beside the gallery; tapping one picks that box size (it no longer scrolls).
  offers.forEach((el) => el.addEventListener('click', () => {
    goal = +el.dataset.bbTier;
    pack = ''; // picking a 3 / 6 / 12 box means building your own
    render(); // no scroll: picking a box size keeps you where you are (Aaron, 29 Oct)
    const g = $('[data-bb-saving]'); g.classList.remove('is-pop'); void g.offsetWidth; g.classList.add('is-pop');
  }));
  // Long-distance packs: a tap (or Enter) deals the boxes and takes you to them; Shuffle re-deals the same pack.
  packCards.forEach((el) => {
    const go = () => { dealPack(el.dataset.ldrPack); $('[data-bb-packbar]').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    el.addEventListener('click', go);
    el.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target === el) { e.preventDefault(); go(); } });
  });
  root.addEventListener('click', (ev) => {
    if (ev.target.closest('[data-bb-shuffle]')) dealPack(pack);
    else if (ev.target.closest('[data-bb-unpack]')) { pack = ''; render(); root.dispatchEvent(new CustomEvent('bb:pack', { detail: { pack: '', n: order.length } })); }
  });
  $$('[data-bb-jump]').forEach((b) => b.addEventListener('click', () => $(`#bb-${b.dataset.bbJump}`).scrollIntoView({ behavior: 'smooth' })));
  /* ---- Kit quick view (snippets/lumi-kit-quickview.liquid).
     One source of truth: the qty/order state above. The grid cards, the bottom tray, the 3/6/12 offers and this
     popup are all drawn from it by render(); "Add to bundle" just calls set() like the card buttons do, and
     render() calls qvSync() so the popup's "in your box" line never goes stale. */
  const qv = $('[data-bbq]');
  if (qv) {
    const QV = JSON.parse($('[data-bb-qv-data]').textContent);
    // Lift the popup to <body> so it layers (and blurs) above everything, including the sticky tray.
    document.body.appendChild(qv);
    const FILES = 'https://cdn.shopify.com/s/files/1/0685/2585/0683/files/';
    const WORD = ['', 'Easy', 'Regular', 'A challenge!'];
    const ALT = { zoom: 'with its air-dry clay pack', tub: 'clay tub held in hand', flatlay: 'kit laid out: clay, tools, card and board', stretch1: 'clay being stretched', stretch2: 'second clay colour being stretched', swing: 'sitting on a clay swing' };
    const track = $('[data-bbq-track]', qv), thumbs = $('[data-bbq-thumbs]', qv), dots = $('[data-bbq-dots]', qv);
    const dialog = $('[data-bbq-dialog]', qv), qEl = $('[data-bbq-q]', qv);
    let cur = null, pick = 1, idx = 0, lastFocus = null, raf = 0;

    const markSlide = (i) => {
      idx = i;
      [...thumbs.children].forEach((t, k) => t.setAttribute('aria-pressed', String(k === i)));
      [...dots.children].forEach((d, k) => d.classList.toggle('on', k === i));
      const t = thumbs.children[i]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    const go = (i) => { const n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    track.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) markSlide(i); }); }, { passive: true });

    qvSync = () => {
      if (!cur) return;
      const inBox = qty[cur] || 0;
      const n = total();
      $('[data-bbq-inbox]', qv).textContent = inBox ? `✓ ${inBox} in your box` : '';
      const next = tiers.find((t) => t.qty > n) || top;
      $('[data-bbq-box-price]', qv).textContent = `or ${money(next.each)} each in a ${next.qty}-kit box`;
      // Phones: struck $20 next to what this kit costs in a box ($15 from 3 kits, dropping as the box grows).
      const nowEach = tierFor(n + pick) ? tierFor(n + pick).each : next.each;
      $('[data-bbq-now]', qv).textContent = money(nowEach);
      const mob = matchMedia('(max-width: 749px)').matches;
      $('[data-bbq-was]', qv).hidden = !mob;
      $('[data-bbq-list]', qv).style.display = mob ? 'none' : '';
    };
    const setPick = (v) => { pick = Math.max(1, Math.min(12, v)); qEl.textContent = pick; qvSync(); };

    function openQV(slug) {
      const card = bySlug[slug], d = card && QV[card.dataset.slug];
      if (!d || !card) return;
      cur = slug; setPick(1);
      const name = card.dataset.name;
      $('[data-bbq-name]', qv).textContent = name;
      $('[data-bbq-world]', qv).textContent = (card.closest('[data-bb-world]').dataset.bbWorld === 'wild' ? 'Into the Wild' : 'Little Jurassic') + (sideOf(slug) ? ` · for ${cfg.sides[sideOf(slug)].toLowerCase()}` : '');
      $('[data-bbq-tag]', qv).textContent = d.p;
      $('[data-bbq-diff]', qv).dataset.level = d.d;
      $('[data-bbq-diff-word]', qv).textContent = WORD[d.d];
      track.innerHTML = d.i.map(([u, k], i) => `<figure class="bbq-slide is-${k}"><img src="${FILES + u}&width=1000" alt="${name} ${ALT[k] || ''}" ${i ? 'loading="lazy"' : ''} draggable="false"></figure>`).join('');
      thumbs.innerHTML = d.i.map(([u], i) => `<button type="button" class="bbq-thumb" data-bbq-go="${i}" aria-label="Photo ${i + 1}" aria-pressed="${i === 0}"><img src="${FILES + u}&width=160" alt=""></button>`).join('');
      dots.innerHTML = d.i.map((_, i) => `<i class="${i ? '' : 'on'}"></i>`).join('');
      idx = 0; track.scrollLeft = 0;
      qvSync();
      lastFocus = document.activeElement;
      qv.classList.add('is-open'); qv.setAttribute('aria-hidden', 'false');
      // A hidden track ignores scrollLeft, so the last character's slide survived into the next one (Aaron, 10 Oct):
      // reset again once the popup is visible, without the smooth scroll, and re-mark slide 1.
      requestAnimationFrame(() => { track.scrollTo({ left: 0, behavior: 'instant' }); markSlide(0); });
      document.documentElement.classList.add('bbq-lock');
      setTimeout(() => dialog.focus(), 30);
    }
    function closeQV() {
      qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bbq-lock');
      cur = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    root.addEventListener('click', (ev) => {
      const t = ev.target.closest('[data-bb-qv]');
      if (t && !ev.target.closest('button')) openQV(keyOf(t.closest('[data-bb-card]')));
    });
    root.addEventListener('keydown', (ev) => {
      const t = ev.target.closest('[data-bb-qv]');
      if (t && (ev.key === 'Enter' || ev.key === ' ')) { ev.preventDefault(); openQV(keyOf(t.closest('[data-bb-card]'))); }
    });
    qv.addEventListener('click', (ev) => {
      if (ev.target.closest('[data-bbq-close]')) { closeQV(); return; }
      const b = ev.target.closest('button'); if (!b) return;
      if (b.dataset.bbqGo) go(+b.dataset.bbqGo);
      else if (b.dataset.bbqStep) go(idx + +b.dataset.bbqStep);
      else if (b.dataset.bbqD) setPick(pick + +b.dataset.bbqD);
      else if (b.hasAttribute('data-bbq-add')) {
        const slug = cur;
        for (let i = 0; i < pick; i++) set(slug, 1);
        closeQV();
        // Show where it went: pulse the card that just got it.
        const card = bySlug[slug]; card.classList.remove('bb-pulse'); void card.offsetWidth; card.classList.add('bb-pulse');
      }
    });
    document.addEventListener('keydown', (ev) => {
      if (!qv.classList.contains('is-open')) return;
      if (ev.key === 'Escape') closeQV();
      if (ev.key === 'ArrowRight' && ev.target === track) go(idx + 1);
      if (ev.key === 'ArrowLeft' && ev.target === track) go(idx - 1);
    });
  }

  /* Long distance: ship to two addresses (default) or one. Mirrored in the address step via bb:shipto. */
  root.bbShipTo = 'two';
  // Two addresses need MIN_EACH kits a box, so offers smaller than that (the 3-kit one) only show for one address.
  // The offers live in the page's offer slot, outside root, so they're toggled here rather than by CSS.
  function syncTierVis() { if (HH) offers.forEach((el) => { el.hidden = root.bbShipTo !== 'one' && +el.dataset.bbTier < MIN_EACH * 2; }); }
  syncTierVis();
  $$('[data-bb-shipto]').forEach((btn) => btn.addEventListener('click', () => {
    root.bbShipTo = btn.dataset.bbShipto;
    syncTierVis();
    $$('[data-bb-shipto]').forEach((x) => x.setAttribute('aria-checked', String(x === btn)));
    root.dispatchEvent(new CustomEvent('bb:shipto', { detail: root.bbShipTo }));
    render();
  }));
  // Tray pages (past 12 kits): keep the dots in step with the swipe, and let a dot jump to its page.
  $('[data-bb-slots]').addEventListener('scroll', () => requestAnimationFrame(markPage), { passive: true });
  root.addEventListener('click', (ev) => {
    const d = ev.target.closest('[data-bb-page]');
    if (d) { const el = $('[data-bb-slots]'); el.scrollTo({ left: +d.dataset.bbPage * el.clientWidth, behavior: 'smooth' }); }
  });
  // For the address step: the picked lines, the gift reconcile and a way to empty the box once it's in the cart.
  const boxLink = () => location.origin + location.pathname + '?box=' + order.map((k) => k.replace(':', '-')).join(',') + (pack ? '&pack=' + pack : '');
  root.bb = { lineItems, reconcile, clearBox, req, total, price, money, cfg, shipRate, render, boxLink, sideCount, order, pack: () => pack };

  restoreBox();
  // A packs-only page has nothing to build, so arriving without a pack deals the featured one.
  if (cfg.packsOnly && !pack && PACKS.length) dealPack((packCards.find((el) => el.classList.contains('is-featured')) || packCards[0] || {}).dataset?.ldrPack || PACKS[0].key, true);
  render();
})();

/* Gift info panel (sections/lumi-box-builder.liquid, [data-bbg]). Tap or Enter on any [data-bb-gift] (the 3/6/12
   offers live outside the builder root, so this listens on document). Stops the click so an offer card doesn't
   also scroll to the builder. */
(() => {
  const box = document.querySelector('[data-bbg]');
  const dataEl = document.querySelector('[data-bb-gift-data]');
  if (!box || !dataEl) return;
  let data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  document.body.appendChild(box);
  const card = box.querySelector('.bbg-card');
  const truck = document.querySelector('.lumi-truck');
  let last = null;
  function open(el) {
    const g = data[el.dataset.bbGift];
    if (!g) return;
    last = el;
    const art = box.querySelector('[data-bbg-art]');
    art.innerHTML = g.img ? `<img src="${g.img}" alt="" width="250" height="250">` : (truck ? truck.outerHTML : '');
    art.removeAttribute('data-bleed');
    const im = art.querySelector('img');
    if (im) {
      // Cutouts like the tool kit (a hand holding the tools) are cut off at the photo's right/bottom edge. Find which
      // edges the picture touches and pin it to those sides of the frame, so the cut runs off-frame (Aaron, 10 Oct).
      const edges = () => {
        try {
          const c = document.createElement('canvas'), S = 48; c.width = c.height = S;
          const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, S, S);
          const a = x.getImageData(0, 0, S, S).data, at = (i, j) => a[(j * S + i) * 4 + 3] > 40;
          let r = 0, b = 0, l = 0;
          for (let k = 0; k < S; k++) { r += at(S - 1, k); b += at(k, S - 1); l += at(0, k); }
          art.dataset.bleed = [r > 3 && 'r', b > 3 && 'b', l > 3 && 'l'].filter(Boolean).join(' ');
        } catch (e) { /* cross-origin image: keep the default centring */ }
      };
      im.complete && im.naturalWidth ? edges() : im.addEventListener('load', edges, { once: true });
    }
    if (g.qty > 1) art.insertAdjacentHTML('beforeend', `<span class="bbg-qty">×${g.qty}</span>`);
    box.querySelector('[data-bbg-name]').textContent = g.name;
    box.querySelector('[data-bbg-worth]').textContent = g.worth;
    box.querySelector('[data-bbg-save]').textContent = `Save ${g.worth}`;
    box.querySelector('[data-bbg-benefit]').textContent = g.benefit || '';
    // How close the box is: "3 of 12 kits · add 9 more to get it free", or "✓ It's in your box".
    const at = +el.dataset.bbAt || 0, have = window.lumiBoxCount ? window.lumiBoxCount() : 0;
    const got = at && have >= at;
    box.querySelector('[data-bbg-bar]').style.width = at ? `${Math.min(100, (have / at) * 100)}%` : '0%';
    box.querySelector('[data-bbg-unlock]').innerHTML = !at ? (el.dataset.bbUnlock || '')
      : `<b>${got ? '✓ Included in your order' : `Free with ${at} kits`}</b><span class="bbg-count">${Math.min(have, at)} of ${at}</span>`;
    box.classList.toggle('is-got', !!got);
    box.querySelector('[data-bbg-cta]').innerHTML = got ? 'Back to my box <span aria-hidden="true">→</span>'
      : have ? `Add ${at - have} more kit${at - have > 1 ? 's' : ''} <span aria-hidden="true">→</span>` : 'Pick your kits <span aria-hidden="true">→</span>';
    box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false');
    setTimeout(() => card.focus(), 30);
  }
  function close() {
    box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true');
    if (last) last.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-bb-gift]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation(); open(el);
  }, true);
  document.addEventListener('keydown', (e) => {
    if (box.classList.contains('is-open') && e.key === 'Escape') { close(); return; }
    const el = e.target.closest && e.target.closest('[data-bb-gift]');
    if (el && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(el); }
  });
  box.querySelectorAll('[data-bbg-close]').forEach((b) => b.addEventListener('click', close));
  box.querySelector('[data-bbg-cta]').addEventListener('click', () => {
    close();
    const t = document.getElementById('build-your-box');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
